module.exports = "<ng-template [ngIf]=\"modal\">\r\n\t<div class=\"blackscreen\" (click)=\"close()\" [@blackScreen]></div>\r\n</ng-template>\r\n\r\n<ng-template #modalContent></ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/cases/components/cases-modal-container/cases-modal-container.component.html
// module id = ../../../../../src/app/packages/menu-items/cases/components/cases-modal-container/cases-modal-container.component.html
// module chunks = main